<!-- =========================================================================================

  説明: ダイアログでプロフィール画像をアップロードするコンポーネント
  作成者: Kokichi

========================================================================================== -->

<template>
  <div>
    <vs-prompt
      @accept="save"
      @cancel="cancel"
      @close="close"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
      :is-valid="isValid"
    >
      <vs-progress
        v-show="showProgress"
        indeterminate
        color="primary"
      ></vs-progress>

      <div
        v-if="!imgSrc"
        :class="[isDrag ? dragoverClass : dragleaveClass]"
        @dragover.prevent="checkDrag($event, true)"
        @dragleave.prevent="checkDrag($event, false)"
        @drop.prevent="setImage($event)"
        @click="$refs.update_photo_input.click()"
      >
        <input
          type="file"
          ref="update_photo_input"
          class="hidden"
          @change="setImage($event)"
        />
        <span
          >画像ファイルをドロップ、<br />またはクリックしてファイルを選択</span
        >
      </div>

      <vue-cropper
        v-if="isCrop"
        ref="cropper"
        :src="imgSrc"
        :autoCropArea="0.8"
        :dragMode="'move'"
        :restore="false"
        :guides="false"
        :center="false"
        :highlight="false"
        :background="false"
        :cropBoxMovable="false"
        :cropBoxResizable="false"
        :aspectRatio="1 / 1"
        :toggleDragModeOnDblclick="false"
      ></vue-cropper>
    </vs-prompt>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { FileUtil } from "@/utils";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const picApi = AiseaApiFactory.get("picture");

export default {
  components: { VueCropper },
  data() {
    return {
      showDialog: false,
      title: "プロフィール画像の変更",
      acceptText: "保存",
      cancelText: "キャンセル",
      isValid: false,
      showProgress: false,
      pictureData: {},
      pictureUrl: null,
      imgSrc: null,
      fileType: null,
      cropImg: null,
      isDrag: false,
      isCrop: null,
      dragleaveClass: "drag-area-dragleave",
      dragoverClass: "drag-area-dragover"
    };
  },
  methods: {
    show() {
      this.showDialog = true;
      this.title = "プロフィール画像の選択";
    },
    save() {
      this.isCrop = false;
      let base64 = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.uploadImage(FileUtil.toBlob(base64, this.fileType));
    },
    close() {
      this.cleanUp();
    },
    cancel() {
      this.cleanUp();
    },
    checkDrag(e, isDrag) {
      this.isDrag = isDrag;
    },
    setImage(e) {
      this.title = "プロフィール画像のトリミング";
      const file =
        typeof e.target.files !== "undefined"
          ? e.target.files[0]
          : e.dataTransfer.files[0];

      if (file.type.indexOf("image/") === -1) {
        return;
      }
      this.fileType = file.type
      let reader = new FileReader();
      reader.onload = e => {
        this.imgSrc = e.target.result;
        this.isValid = true;
        this.isCrop = true;
      };
      reader.readAsDataURL(file);
    },
    async uploadImage(inputFile) {
      this.$vs.loading()
      let formData = new FormData();
      formData.append("data", inputFile);
      try {
        let response = await picApi.addUserPicture({ formData: formData });
        this.pictureData = response.data;
        this.getPictureUrl();
      }catch (e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "プロフィール画像の登録に失敗しました",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        this.close()
      }
    },
    getPictureUrl() {
      storage
        .child(this.pictureData.original_path)
        .getDownloadURL()
        .then(response => {
          this.pictureUrl = response;
          setTimeout(() => {
            this.onImageUpdated();
          }, 2000);
        })
        .catch(error => {
          //FireStoreにサムネイルができるまでリトライ
          if (error.code === "storage/object-not-found") {
            setTimeout(() => {
              this.getPictureUrl(this.pictureData.original_path);
            }, 3000);
          }
        });
    },
    onImageUpdated() {
      this.$emit("onImageUploaded", {
        data: this.pictureData,
        url: this.pictureUrl
      });
      this.$vs.loading.close()
      this.cleanUp();
    },
    cleanUp() {
      this.showDialog = false;
      this.showProgress = false;
      this.imgSrc = null;
      this.isCrop = false;
      this.isDrag = false;
      this.title = "プロフィール画像の選択";
    }
  }
};
</script>

<style lang="scss">
.drag-area-dragleave {
  width: 100%;
  min-width: 200px;
  height: 100%;
  min-height: 200px;
  border: 2px dotted rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f5f5f5;
  text-align: center;
}

.drag-area-dragover {
  width: 100%;
  min-width: 200px;
  height: 100%;
  min-height: 200px;
  border: 2px solid rgba(115, 103, 240, 1);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f5f5f5;
  text-align: center;
}

.con-vs-dialog {
  //プレビューのとき重なりの順序を変更するためz-indexを指定
  z-index: 60000;
}
</style>
